import _IconMenuFold from "@arco-design/web-react/icon/react-icon/IconMenuFold";
import _IconMenuUnfold from "@arco-design/web-react/icon/react-icon/IconMenuUnfold";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import _IconStamp from "@arco-design/web-react/icon/react-icon/IconStamp";
import _IconIdcard from "@arco-design/web-react/icon/react-icon/IconIdcard";
import _IconEdit from "@arco-design/web-react/icon/react-icon/IconEdit";
import _IconMenu from "@arco-design/web-react/icon/react-icon/IconMenu";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import _IconExclamationCircle from "@arco-design/web-react/icon/react-icon/IconExclamationCircle";
import _IconCheckCircle from "@arco-design/web-react/icon/react-icon/IconCheckCircle";
import _IconApps from "@arco-design/web-react/icon/react-icon/IconApps";
import _IconFile from "@arco-design/web-react/icon/react-icon/IconFile";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import _IconList from "@arco-design/web-react/icon/react-icon/IconList";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import cs from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import qs from 'query-string';
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import TabBar from './components/TabBar';
import useRoute from '@/routes';
import useLocale from './utils/useLocale';
import getUrlParams from './utils/getUrlParams';
import lazyload from './utils/lazyload';
import styles from './style/layout.module.less';
const MenuItem = _Menu.Item;
const SubMenu = _Menu.SubMenu;
const Sider = _Layout.Sider;
const Content = _Layout.Content;

// 导入iconMap
import iconMap from './components/IconPicker';
function getIconFromKey(key, iconFromRoute) {
  // 优先使用路由中定义的图标
  if (iconFromRoute) {
    const IconComponent = iconMap[iconFromRoute];
    if (IconComponent) {
      return /*#__PURE__*/React.createElement(IconComponent, {
        className: styles.icon
      });
    }
  }

  // 如果没有指定图标或图标不存在，使用原来的逻辑
  switch (key) {
    case 'dashboard':
      return /*#__PURE__*/React.createElement(_IconDashboard, {
        className: styles.icon
      });
    case 'list':
      return /*#__PURE__*/React.createElement(_IconList, {
        className: styles.icon
      });
    case 'form':
      return /*#__PURE__*/React.createElement(_IconSettings, {
        className: styles.icon
      });
    case 'profile':
      return /*#__PURE__*/React.createElement(_IconFile, {
        className: styles.icon
      });
    case 'visualization':
      return /*#__PURE__*/React.createElement(_IconApps, {
        className: styles.icon
      });
    case 'result':
      return /*#__PURE__*/React.createElement(_IconCheckCircle, {
        className: styles.icon
      });
    case 'exception':
      return /*#__PURE__*/React.createElement(_IconExclamationCircle, {
        className: styles.icon
      });
    case 'user':
      return /*#__PURE__*/React.createElement(_IconUser, {
        className: styles.icon
      });
    case 'system':
      return /*#__PURE__*/React.createElement(_IconMenu, {
        className: styles.icon
      });
    case 'general_ledger':
      return /*#__PURE__*/React.createElement(_IconEdit, {
        className: styles.icon
      });
    case 'suppliers':
      return /*#__PURE__*/React.createElement(_IconIdcard, {
        className: styles.icon
      });
    case 'customers':
      return /*#__PURE__*/React.createElement(_IconIdcard, {
        className: styles.icon
      });
    case 'reports':
      return /*#__PURE__*/React.createElement(_IconFile, {
        className: styles.icon
      });
    case 'companies':
      return /*#__PURE__*/React.createElement(_IconStamp, {
        className: styles.icon
      });
    default:
      return /*#__PURE__*/React.createElement("div", {
        className: styles['icon-empty']
      });
  }
}
function getFlattenRoutes(routes) {
  const res = [];
  function travel(_routes) {
    _routes.forEach(route => {
      const visibleChildren = (route.children || []).filter(child => !child.ignore);

      // 检查路由是否应该生成页面组件
      if (route.key && (!route.children || !visibleChildren.length)) {
        try {
          // 如果路由还没有组件，则动态加载
          if (!route.component) {
            route.component = lazyload(() => import(`./pages/${route.key}`));
          }
          res.push(route);
        } catch (e) {
          console.error(`加载路由组件失败: ./pages/${route.key}`, e);
        }
      }
      if (route.children && route.children.length) {
        travel(route.children);
      }
    });
  }
  travel(routes);
  return res;
}
function PageLayout() {
  const urlParams = getUrlParams();
  const history = useHistory();
  const pathname = history.location.pathname;
  const currentComponent = qs.parseUrl(pathname).url.slice(1);
  const locale = useLocale();
  const dispatch = useDispatch();
  const {
    settings,
    userLoading,
    userInfo,
    tabs,
    activeTab,
    visitedTabs
  } = useSelector(state => state);

  // 修改这一行，从userInfo中获取菜单数据
  const [routes, defaultRoute] = useRoute(userInfo?.permissions, userInfo?.menus);
  const defaultSelectedKeys = [currentComponent || defaultRoute];
  const paths = (currentComponent || defaultRoute).split('/');
  const defaultOpenKeys = paths.slice(0, paths.length - 1);
  const [collapsed, setCollapsed] = useState(true);
  const [selectedKeys, setSelectedKeys] = useState(defaultSelectedKeys);
  const [openKeys, setOpenKeys] = useState(defaultOpenKeys);
  const menuMap = useRef(new Map());
  const navbarHeight = 60;
  const menuWidth = collapsed ? 48 : settings.menuWidth;
  const showNavbar = settings.navbar && urlParams.navbar !== false;
  const showMenu = settings.menu && urlParams.menu !== false;
  const showFooter = settings.footer && urlParams.footer !== false;
  const flattenRoutes = useMemo(() => getFlattenRoutes(routes) || [], [routes]);
  function renderRoutes(locale) {
    return function travel(_routes, level, parentNode = []) {
      return _routes.map(route => {
        const {
          ignore
        } = route;
        const iconDom = getIconFromKey(route.key, route.icon);
        const titleDom = /*#__PURE__*/React.createElement(React.Fragment, null, iconDom, " ", locale[route.name] || route.name);
        const visibleChildren = (route.children || []).filter(child => {
          return !child.ignore;
        });
        if (ignore) {
          return '';
        }
        if (visibleChildren.length) {
          menuMap.current.set(route.key, {
            subMenu: true
          });
          return /*#__PURE__*/React.createElement(SubMenu, {
            key: route.key,
            title: titleDom
          }, travel(visibleChildren, level + 1, [...parentNode, route.name]));
        }
        menuMap.current.set(route.key, {
          menuItem: true
        });
        const href = route.path || `/${route.key}`;
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: route.key
        }, /*#__PURE__*/React.createElement("a", {
          href: href,
          style: {
            color: 'inherit',
            textDecoration: 'none',
            display: 'block'
          },
          onClick: e => e.preventDefault()
        }, titleDom));
      });
    };
  }
  function onClickMenuItem(key) {
    const currentRoute = flattenRoutes.find(r => r.key === key);
    const url = currentRoute?.path ? currentRoute.path : `/${key}`;
    const title = locale[currentRoute?.name] || currentRoute?.name || key;

    // 添加 Tab
    dispatch({
      type: 'add-tab',
      payload: {
        tab: {
          key,
          title,
          closable: true
        }
      }
    });

    // 路由跳转
    history.push(url);
  }
  function toggleCollapse() {
    setCollapsed(collapsed => !collapsed);
  }
  const paddingLeft = showMenu ? {
    paddingLeft: menuWidth
  } : {};
  const paddingTop = showNavbar ? {
    paddingTop: navbarHeight
  } : {};
  const paddingStyle = {
    ...paddingLeft,
    ...paddingTop
  };
  function updateMenuStatus() {
    const pathKeys = pathname.split('/');
    const newSelectedKeys = [];
    const newOpenKeys = [...openKeys];
    while (pathKeys.length > 0) {
      const currentRouteKey = pathKeys.join('/');
      const menuKey = currentRouteKey.replace(/^\//, '');
      const menuType = menuMap.current.get(menuKey);
      if (menuType && menuType.menuItem) {
        newSelectedKeys.push(menuKey);
      }
      if (menuType && menuType.subMenu && !openKeys.includes(menuKey)) {
        newOpenKeys.push(menuKey);
      }
      pathKeys.pop();
    }
    setSelectedKeys(newSelectedKeys);
    setOpenKeys(newOpenKeys);
  }
  useEffect(() => {
    updateMenuStatus();

    // 路由变化时自动添加/激活 Tab
    if (pathname && pathname !== '/') {
      const routeKey = pathname.replace(/^\//, '');
      const currentRoute = flattenRoutes.find(r => r.key === routeKey);
      if (currentRoute) {
        const title = locale[currentRoute.name] || currentRoute.name || routeKey;
        dispatch({
          type: 'add-tab',
          payload: {
            tab: {
              key: routeKey,
              title,
              closable: true
            }
          }
        });
      }
    }
  }, [pathname]);
  return /*#__PURE__*/React.createElement(_Layout, {
    className: styles.layout
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(styles['layout-navbar'], {
      [styles['layout-navbar-hidden']]: !showNavbar
    })
  }, /*#__PURE__*/React.createElement(Navbar, {
    show: showNavbar
  })), userLoading ? /*#__PURE__*/React.createElement(_Spin, {
    className: styles['spin']
  }) : /*#__PURE__*/React.createElement(_Layout, null, showMenu && /*#__PURE__*/React.createElement(Sider, {
    className: styles['layout-sider'],
    width: menuWidth,
    collapsed: collapsed,
    onCollapse: setCollapsed,
    trigger: null,
    collapsible: true
    // breakpoint="xl"
    ,
    style: paddingTop
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['menu-wrapper']
  }, /*#__PURE__*/React.createElement(_Menu, {
    collapse: collapsed,
    onClickMenuItem: onClickMenuItem,
    selectedKeys: selectedKeys,
    openKeys: openKeys,
    onClickSubMenu: (_, openKeys) => setOpenKeys(openKeys)
  }, renderRoutes(locale)(routes, 1))), /*#__PURE__*/React.createElement("div", {
    className: styles['collapse-btn'],
    onClick: toggleCollapse
  }, collapsed ? /*#__PURE__*/React.createElement(_IconMenuUnfold, null) : /*#__PURE__*/React.createElement(_IconMenuFold, null))), /*#__PURE__*/React.createElement(_Layout, {
    className: styles['layout-content'],
    style: paddingStyle
  }, /*#__PURE__*/React.createElement(TabBar, null), /*#__PURE__*/React.createElement("div", {
    className: styles['layout-content-wrapper']
  }, /*#__PURE__*/React.createElement(Content, null, !tabs?.length && !activeTab && /*#__PURE__*/React.createElement(Redirect, {
    to: `/${defaultRoute}`
  }), (visitedTabs || []).map(tabKey => {
    const tab = tabs?.find(t => t.key === tabKey);
    if (!tab) return null;
    const route = flattenRoutes.find(r => r.key === tabKey);
    if (!route) return null;
    const Component = route.component;
    const isActive = activeTab === tabKey;
    return /*#__PURE__*/React.createElement("div", {
      key: tabKey,
      style: {
        display: isActive ? 'block' : 'none',
        height: '100%'
      }
    }, /*#__PURE__*/React.createElement(Component, {
      key: tab.refreshKey || 0
    }));
  }))), showFooter && /*#__PURE__*/React.createElement(Footer, null))));
}
export default PageLayout;